<template>
    <div class="container-fluid">
        <div class="row" ref="container">
            <div class="col-sm-12 text-center" ref="loader">
                <div class="container">
                    <img :src="post.header_image_url" class="img-fluid shadow w-100 img-head">
                </div>
            </div>
            <div class="col-sm-12">
                <div class="container">
                    <div class="card shadow">
                        <div class="card-body">
                            <h1 class="mt-2 text-wellis-gold">{{post.title}}</h1>
                            <hr>
                            <div class="mt-4" v-html="nl2br(post.content)"></div>
                        </div>
                        <div class="card-footer text-wellis-gold">
                            <div class="float-left">{{post.author_name}}</div>
                            <div class="float-right">{{post.created_at | formatDate(true)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsApiService from "@/api/news.api";
import {empty, nl2br} from "@/helpers";

export default {
    name: "NewsDetails",
    data() {
        return {
            post: {}
        }
    },

    created() {
        this.fetch(this.$route.params.slug);
    },

    methods: {
        fetch(slug) {
            this.showLoader();
            NewsApiService.concrete(slug)
                .then(response => this.post = response.data)
                .catch(() => this.$router.push({name: 'app.404'}))
                .finally(() => this.hideLoader());
        },

        showLoader: function () {
            if (!empty(this.loader)) {
                this.loader.hide();
                this.loader = null;
            }
            this.loader = this.$loading.show({
                container: this.$refs.container
            });
        },

        hideLoader: function () {
            if (!empty(this.loader)) {
                this.loader.hide();
                this.loader = null;
            }
        },
    },

    computed: {
        nl2br() {
            return value => {
                return nl2br(value);
            }
        }
    }
}
</script>

<style scoped>
.img-head {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}
</style>
